export default __webpack_public_path__ + "locales/lv/EmptyView.json?hash=b5f355b446538131255764c2065fac7c";